import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import { useLocation } from "react-router-dom";


const Table16 = ({ halemasaleScore, setHalemasaleScore, reload }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const { setGreadingScore } = useContext(jobContext)


  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.halemasale;
    if (items) {
      const masouliat = items[Object.keys(items)[0]];
      const masouliatData = [
        { name: "سطح یک", score: 8, isSelected: masouliat.value == 0 },
        { name: "سطح دو", score: 16, isSelected: masouliat.value == 1 },
        { name: "سطح سه", score: 24, isSelected: masouliat.value == 2 },
        { name: "سطح چهار", score: 32, isSelected: masouliat.value == 3 },
        { name: "سطح پنج", score: 40, isSelected: masouliat.value == 4 },

      ]

      const selectedItem = masouliatData.find((i) => i.isSelected)?.score
      setHalemasaleScore(selectedItem)
      setGreadingScore((prev) => ({ ...prev, "halemasale": selectedItem }))
    }
  }, [reload])



  return (
    <div>
      <Row type={1}>
        <Column >سطح یک</Column>
        <Column >سطح دو</Column>
        <Column >سطح سه</Column>
        <Column >سطح چهار</Column>
        <Column >سطح پنج</Column>
      </Row>
      <Row type={2}>
        <Column paddingY={30}>
          مسائل و مشکالت
          تکراری و روتین و
          مشخص
        </Column>
        <Column paddingY={30}>
          مسائل و مشکالت نیمه
          روتین
        </Column>
        <Column paddingY={30}>
          مسائل و مشکالت
          استاندارد با رویه های
          نسبتاً مشخص
        </Column>
        <Column paddingY={30}>
          مسائل و مشکالت
          تعریف شده واضح
        </Column>
        <Column paddingY={30}>
          مسائل و مشکالت بدون
          الگو ، وسیع ، کلی و
          انتزاعی
        </Column>
      </Row>
      <Row>
        <Column isActive={halemasaleScore == 8}> 8</Column>
        <Column isActive={halemasaleScore == 16}>16 </Column>
        <Column isActive={halemasaleScore == 24}>24 </Column>
        <Column isActive={halemasaleScore == 32}> 32</Column>
        <Column isActive={halemasaleScore == 40}> 40</Column>
      </Row>
    </div>
  );
};

export default Table16;
